// @ts-strict-ignore
import type { HighchartsWrapperProps } from "../types";

/**
 * A graph without titles / axes / etc.
 * @note Extend this to get the base config for a minimal highcharts instance.
 */
export const getMinimalistConfig = (): HighchartsWrapperProps["chartConfig"] => {
  return {
    legend: {
      enabled: false,
    },
    title: {
      text: null,
    },
    yAxis: {
      title: {
        text: null,
      },
      labels: {
        enabled: true,
      },
      maxPadding: 0,
      gridLineWidth: 0,
      lineWidth: 1,
    },
    xAxis: {
      labels: {
        enabled: false,
      },
      gridLineWidth: 0,
      lineWidth: 0,
    },
  };
};
